import constate from 'constate'

import useLiveTrends from '../data/useLiveTrends'

const [LiveTrendsProvider, useLiveTrendsContext] = constate(useLiveTrends)

export { LiveTrendsProvider, useLiveTrendsContext }
